// extracted by mini-css-extract-plugin
export default {"root":"Quote__root--yzdxr","footer":"Quote__footer--u4r7C","right":"Quote__right--n_B7T","total":"Quote__total--YpWHV"};